module.exports = __webpack_public_path__ + "img/mes-refresh.1033c3e5.svg";